import React from "react";
import cx from "classnames";
import importedStyles from "./IconField.module.css";

const styles: Record<string, string> =
  typeof importedStyles === "undefined" ? {} : importedStyles;

export type IconFieldVariant = "compact" | "sidebar" | "sheet";

type IconFieldControlKind = "input" | "select";

interface IconFieldProps {
  variant: IconFieldVariant;
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
  iconSrc?: string;
  invalid?: boolean;
}

const variantFieldClassName: Record<IconFieldVariant, string> = {
  compact: styles.compactField,
  sidebar: styles.sidebarField,
  sheet: styles.sheetField,
};

const variantIconWellClassName: Record<IconFieldVariant, string> = {
  compact: styles.compactIconWell,
  sidebar: styles.sidebarIconWell,
  sheet: styles.sheetIconWell,
};

const variantIconClassName: Record<IconFieldVariant, string> = {
  compact: styles.compactIcon,
  sidebar: styles.sidebarIcon,
  sheet: styles.sheetIcon,
};

const controlClassNameByVariantAndKind: Record<
  IconFieldVariant,
  Record<IconFieldControlKind, string>
> = {
  compact: {
    input: styles.compactInput,
    select: styles.compactInput,
  },
  sidebar: {
    input: styles.sidebarInput,
    select: styles.sidebarSelect,
  },
  sheet: {
    input: styles.sheetInput,
    select: styles.sheetSelect,
  },
};

export const getIconFieldControlClassName = ({
  variant,
  kind = "input",
  className,
}: {
  variant: IconFieldVariant;
  kind?: IconFieldControlKind;
  className?: string;
}) =>
  cx(
    styles.control,
    controlClassNameByVariantAndKind[variant][kind],
    className
  );

export const getIconFieldIconClassName = (variant: IconFieldVariant) =>
  cx(styles.icon, variantIconClassName[variant]);

const IconField = ({
  variant,
  icon,
  iconSrc,
  children,
  className,
  invalid = false,
}: IconFieldProps) => (
  <div
    className={cx(
      styles.field,
      variantFieldClassName[variant],
      invalid && styles.invalidField,
      className
    )}
  >
    <span className={cx(styles.iconWell, variantIconWellClassName[variant])}>
      {icon ||
        (iconSrc ? (
          <img
            alt=""
            className={getIconFieldIconClassName(variant)}
            src={iconSrc}
          />
        ) : null)}
    </span>
    {children}
  </div>
);

export default IconField;
